const { BorderRadius } = require('./borderRadius')
const { BoxShadow } = require('./boxShadow')
const { Color } = require('./colors')
const { ChartingColors } = require('./chartingColors')
const { FontFamilies } = require('./fontFamilies')
const { Spacing } = require('./spacing')
const { Typography } = require('./typography')

module.exports = {
  BorderRadius,
  BoxShadow,
  Color,
  ChartingColors,
  FontFamilies,
  Spacing,
  Typography,
};